import { React } from 'react';
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Carousel from "../components/Carousel"

import SmallBuisness from "../assets/Home/smallBusiness.jpeg"
import CommercialIndustrial from "../assets/Home/commercialIndustrial.jpeg"
import Education from "../assets/Home/education.jpeg"
import NonProfit from "../assets/Home/nonProfit.jpeg"
import Hospitality from "../assets/Home/hospitality.jpeg"


import BusinessIcon from '@material-ui/icons/Business';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import MoneyOffIcon from '@material-ui/icons/MoneyOff';
import HotelIcon from '@material-ui/icons/Hotel';
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import CheckIcon from '@material-ui/icons/Check';
import MouseIcon from '@material-ui/icons/Mouse';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const Home = () => {
    return (  
        <div>
            <Helmet>
                <title>Rave Energy - Commercial</title>
                <meta name="keywords" content="HTML,CSS,JavaScript" />
                <meta
                    name="description"
                    content="Rave Energy commercial energy provider home page."
                />
            </Helmet>
            <main>
                <div className="flex sm:flex-row flex-col h-screen">
                    <Carousel />
                    <a href="#reverseAuction" className="hidden md:flex bg-red-500 absolute items-center bottom-0 left-0 w-48 h-20 text-white rounded-tr-full pt-4 px-16 ">
                        <div className="flex flex-col justify-center hover:animate-bounce">
                        <MouseIcon className="mt-2" style={{ fontSize: `30px`}} />
                        <ExpandMoreIcon className="-mt-2" style={{ fontSize: `30px`}} />
                        </div>
                    </a>
                    <div className="flex-col sm:w-2/5 h-0 sm:h-screen md:h-screen lg:h-screen w-screen hidden sm:flex md:flex lg:flex xl:flex">
                        <Link className="h-1/5" to="/small-business">
                            <div className="flex flex-col justify-center items-center text-white text-sm sm:text-base md:text-xl lg:text-3xl xl:text-3xl h-full bg-center bg-140 lg:bg-100 lg:hover:bg-110 tansition-all duration-1000 border border-black" style={{ backgroundImage: `url(${SmallBuisness})`}}>
                                <BusinessCenterIcon style={{ fontSize: `40px`}} />
                                <hr className="white w-1/2 border hidden sm:block"/>
                                <h1 className="font-medium">SMALL BUSINESS</h1>
                            </div>
                        </Link>
                        <Link className="h-1/5" to="/commercial-industrial">
                            <div className="flex flex-col justify-center items-center text-white text-sm sm:text-base md:text-xl lg:text-3xl xl:text-3xl h-full bg-center bg-140 lg:bg-100 lg:hover:bg-110 tansition-all duration-1000 border border-black text-center" style={{ backgroundImage: `url(${CommercialIndustrial})`}}>
                                <BusinessIcon style={{ fontSize: `40px`}} />
                                <hr className="white w-1/2 border hidden sm:block" />
                                <h1 className="font-medium">COMMERCIAL AND INDUSTRIAL</h1> 
                            </div>
                        </Link>
                        <Link className="h-1/5" to="/education">
                            <div className="flex flex-col justify-center items-center text-white text-sm sm:text-base md:text-xl lg:text-3xl xl:text-3xl h-full bg-center bg-140 lg:bg-100 lg:hover:bg-110 tansition-all duration-1000 border border-black" style={{ backgroundImage: `url(${Education})`}}>
                                <MenuBookIcon style={{ fontSize: `40px`}} />
                                <hr className="white w-1/2 border hidden sm:block" />
                                <h1 className="font-medium">EDUCATION</h1>
                            </div>
                        </Link>
                        <Link className="h-1/5" to="/non-profit">
                            <div className="flex flex-col justify-center items-center text-white text-sm sm:text-base md:text-xl lg:text-3xl xl:text-3xl h-full bg-center bg-140 lg:bg-100 lg:hover:bg-110 tansition-all duration-1000 border border-black" style={{ backgroundImage: `url(${NonProfit})`}}>
                                <MoneyOffIcon style={{ fontSize: `40px`}} />
                                <hr className="white w-1/2 border hidden sm:block" />
                                <h1 className="font-medium">NON-PROFIT</h1>
                            </div>
                        </Link>
                        <Link className="h-1/5" to="/hospitality">
                            <div className="flex flex-col justify-center items-center text-white text-sm sm:text-base md:text-xl lg:text-3xl xl:text-3xl h-full bg-bottom bg-140 lg:bg-100 lg:hover:bg-110 tansition-all duration-1000 border border-black" style={{ backgroundImage: `url(${Hospitality})`}}>
                                <HotelIcon style={{ fontSize: `40px`}} />
                                <hr className="white w-1/2 border hidden sm:block" />
                                <h1 className="font-medium">HOSPITALITY</h1>
                            </div>
                        </Link>
                    </div>
                </div>
                
                <div style={{ color : `#2C3E50` }} id="reverseAuction" className="flex flex-col justify-center items-center py-0 sm:py-8 md:py-8 lg:py-8 xl:py-8 -mt-80 xs:-mt-64 xsLandscape:-mt-24 sm:mt-0 md:mt-0 lg:mt-0 xl:mt-0">
                    <h1 className="font-medium tracking-tighter sm:text-6xl text-4xl mt-0 sm:mt-6 md:mt-6 lg:mt-6 xl:mt-6 text-center">Energy <span className="text-red-500"> Reverse Auctions</span></h1>
                    <p className="max-w-4xl mt-4 text-xl font-light text-center">Using our reverse auction, we help businesses, schools, and all types of organizations procure the lowest possible electricity and natural gas rates. Simply put: when suppliers compete, you win.</p>               
                    <div className="flex flex-col mt-6 px-2">
                        <h1><CheckIcon className="text-red-500" style={{ fontSize : `40px` }} /> We gather all of the competitive suppliers in your market to compete for your business</h1>
                        <h1 className="mt-3"><CheckIcon className="text-red-500" style={{ fontSize : `40px` }} /> To help you make decisions, every auction comes with a detailed summary and cost comparison analysis</h1>
                        <h1  className="mt-3"><CheckIcon className="text-red-500" style={{ fontSize : `40px` }} /> Participating in a reverse auction is free – so you’ll never have to worry about out-of-pocket expenses</h1>
                        <h1 className="mt-3"><CheckIcon className="text-red-500" style={{ fontSize : `40px` }} /> Because we know your time is valuable, auctions last for only approximately 5-10 minutes</h1>
                    </div>
                    <Link className="px-8 py-3 bg-red-500 rounded mt-6 text-white text-center text-xl hover:shadow-md transition duration-500 mb-4" to="/contact">Request a demo</Link>
                </div>
            </main>
        </div>
    );
}
 
export default Home;